<template>
    <header>
        <x-container fluid app-width>
            <x-layout wrap align-center justify-space-between>
                <x-flex :class="{ 'xs6 no-wrap': showResponsePanel }">
                    <status-chip class="status" :class="risk.status" :status="risk.status" />
                    <h1 :class="{ 'hide-text-overflow': showResponsePanel }"><span class="faded">{{ risk.id }}</span> {{ risk.client_company_name }} <span class="faded">{{ risk.obligor_name }}</span> {{ risk.country_name }}</h1>
                </x-flex>

                <x-flex class="grow-0" v-show="!showResponsePanel">
                    <div class="chips">

                        <x-menu v-if="actionMenuItems.length" content-class="actions-menu" offset-y left>
                            <template #activator="{on}">
                                <x-btn
                                    :color="actionButtonColor"
                                    large
                                    v-on="on"
                                >
                                    Actions

                                    <i class="material-icons ml-2">keyboard_arrow_down</i>
                                </x-btn>
                            </template>

                            <x-list>
                                <x-tooltip
                                    v-for="action in actionMenuItems"
                                    :key="action.eventName"
                                    :disabled="!action.disabled || !action.disabledTooltip"
                                    left
                                    nudge-left="3"
                                    debounce="5000"
                                    open-delay="600"
                                    transition="slide-x-transition"
                                >
                                    <template #activator="{on}">
                                        <span v-on="on">
                                            <x-list-tile
                                                :disabled="action.disabled"
                                                @click="handleAction(action)"
                                            >
                                                <x-list-tile-title>{{ action.name }}</x-list-tile-title>
                                            </x-list-tile>
                                        </span>
                                    </template>

                                    <span>{{ action.disabledTooltip }}</span>
                                </x-tooltip>
                            </x-list>
                        </x-menu>

                        <x-btn
                            v-if="risk.status === 'requested'"
                            color="primary"
                            @click="$emit('showResponsePanel')"
                        >
                            <x-icon class="mr-2">note_alt</x-icon>

                            Respond
                        </x-btn>
                    </div>
                </x-flex>
            </x-layout>
        </x-container>
    </header>
</template>

<script>
    import StatusChip from '~/components/Shared/UIComponents/StatusChip';

    export default {
        name: 'RiskHeader',
        components: {
            StatusChip
        },
        props: ['risk', 'actionsSecondary', 'showResponsePanel'],
        data() {
            return {
                actionMenuItems: [],
                hasActiveOffRisk: false
            };
        },
        computed: {
            actionButtonColor() {
                return this.actionsSecondary ? 'secondary' : 'primary';
            }
        },
        created() {
            this.$eventBus.$on('update-action-menu-items', (items) => {
                this.actionMenuItems = items || [];
            })

            this.$eventBus.$on('update-has-active-off-risk', (hasActiveOffRisk) => {
                this.hasActiveOffRisk = hasActiveOffRisk;
            })
        },
        methods: {
            handleAction(action) {
                this.$eventBus.$emit(action.eventName);
            }
        }
    }
</script>

<style lang="scss" scoped>
    header {
        .layout {
            padding: 24px 0 16px;

            h1 {
                font-size: 36px;

                &.hide-text-overflow {
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .faded {
                    opacity: 0.5;
                }
            }

            .chips {
                font-family: $font-title;
            }
        }
    }

    .x-menu__content.actions-menu {
        .x-list {
            .x-list--disabled {
                opacity: 0.35;
            }
        }
    }
</style>
